<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('cast_type_title') }}
                <v-spacer></v-spacer>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        :label="$t('search')"
                        solo
                        v-model="search"
                        @keypress.enter="createdDataFetch"
                        hide-details>
                    </v-text-field>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            :disabled="authorizations.cast_types ? !authorizations.cast_types.create : true"
                            @click="openCastTypeDialog({editMode: false})"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="authorizations.cast_types ? !authorizations.cast_types.create : true">mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_cast_type') }}</v-list-item-title>
                        </v-list-item> 
                        <v-list-item
                            :disabled="!selected.castType[0].meta.editable"
                            v-if="selected.castType.length == 1 && authorizations.cast_types ? authorizations.cast_types.update : false"
                            @click="openCastTypeDialog({editMode: true, id: selected.castType[0].id})"
                            link
                            >
                            <v-list-item-icon>
                                <v-icon >mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_cast_type') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.castType.length && authorizations.cast_types ? authorizations.cast_types.delete : false"
                            :disabled="!selected.castType[0].meta.deletable"
                            @click="openDeleteDialog({ target: 'castType', items: selected.castType })"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="!selected.castType[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_cast_type') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-data-table 
                    show-select
                    single-select
                    dense
                    :headers="headers.castType"
                    :loading="loading.data"
                    :server-items-length="castTypesLength"
                    :options.sync="options"
                    :items="castTypes"
                    v-model="selected.castType">
                </v-data-table>
            </v-card-text>
        </v-card>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <CastTypeDialog
            ref="castTypeDialog"/>
        <DeleteDialog
            ref="deleteDialog"
            @submit="onDeleteDialogSubmit"/>
        <AlertDialog 
            ref="alertDialog"/>
    </div>
</template>

<script>
import RetryDialog from '@/components/common/RetryDialog';
import CastTypeDialog from '@/components/Sales/CastTypesDialog';
import DeleteDialog from '@/components/common/DeleteDialog';
import AlertDialog from '@/components/common/AlertDialog';
import { mapActions, mapState } from 'vuex'
export default {
    name: "CaseTypes",
    components: {
        RetryDialog,
        CastTypeDialog,
        DeleteDialog,
        AlertDialog
    },
    data() {
        return {
            castTypesLength: 0,
            loading: {
                data: false,
            },
            headers: {
                castType: [
                    { text: this.$t('name'), value: "name" }
                ]
            },
            selected: {
                castType: []
            },
            search: null,
            options: {}
        }
    },
     watch: {
        options: {
            handler () {
                this.createdDataFetch();
            },
            deep: true
        }
    },
    computed: {
        ...mapState("sales/castType", ["castTypes"]),
        ...mapState('authentication', ["authorizations"])
    },
    methods: {
        ...mapActions("sales/castType", ["fetchCastTypes", "removeCastTypes"]),
        async createdDataFetch() {
            try {
                this.options.search = this.search;
                this.loading.data = true;
                let result = await this.fetchCastTypes(this.options);
                this.castTypesLength = result.data.total;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
                else this.close()
            }
        },
        openCastTypeDialog(params) {
            this.$refs.castTypeDialog.open(params);
            this.selected.castType = [];
        },
        openDeleteDialog(params) {
            this.$refs.deleteDialog.open(params);
            this.selected.castType = [];
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'castType') {
                this.removeCastTypes({itemsIds: params.itemsIds})
                    .then(() => {
                        this.$refs.deleteDialog.close();
                        this.createdDataFetch();
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
    }
}
</script>